import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../ErrorFallback";
import * as Sentry from "@sentry/react";

/**
 * This is a default error boundary which will catch errors from
 * child components and show the ErrorFallback in its place,
 * and also log the error to Sentry
 *
 * If you have a large component that you want to catch errors
 * from React component lifecycles then wrap it like so:
 *
 * <DefaultErrorBoundary>
 *   <MyComponent />
 * </DefaultErrorBoundary>
 */
export default function DefaultErrorBoundary({ children }) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => {
        console.log("error boundary", error);
        Sentry.captureException(error);
      }}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
